export const AttributeStructureType = {
  Qualitative: "qualitative",
  MedicalAlternatives: "medicalAlternatives",
} as const;

export type AttributeStructureType =
  (typeof AttributeStructureType)[keyof typeof AttributeStructureType];
